import RenovacaoDocumentos from './renovacaoDocumentos';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import {
    listDocumentosSolicitadosAction,
    enviarArquivos
} from '../../store/renovacaoDocumentos/actions';

const mapStateToProps = (state, nextState) => ({
    renovacaoDocumentos: state.renovacaoDocumentosReducer,
});

const mapDispatchToProps = dispatch =>
    bindActionCreators({
        listDocumentosSolicitadosAction,
        enviarArquivos
    }, dispatch);

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(RenovacaoDocumentos);